import * as React from 'react';
import { getValidClasses } from '~/helpers/helpers';
import { directionKindToReadable } from '~/common/maps/maps';
import { MarathonQuestion } from '~/common/types/types';
import { Content } from '~/components/common/common';
import { marathonQuestionSpecialtyToLabel } from './common/maps';
import * as styles from './question.module.scss';

type Props = {
  question: MarathonQuestion;
};

const Question: React.FC<Props> = ({ question }) => {
  const { htmlContent, title, category, specialty } = question;
  const label = marathonQuestionSpecialtyToLabel[specialty];
  const hasLabel = Boolean(label);

  return (
    <details
      className={getValidClasses(styles.marathonQuestion, styles[specialty])}
      open
    >
      <summary className={styles.postMainTitle}>
        [{directionKindToReadable[category]}] {title}
        {hasLabel && <span className={styles.label}>{label}</span>}
      </summary>
      <Content className={styles.postContent} content={htmlContent} />
    </details>
  );
};

export { Question };
